import { Box, Button } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React from "react";
import { IRootStore } from "../stores";
import { STEPS } from "../stores/utils";
import { VerificationIdentity } from "../tutor-revamp/VerificationIdentity";
import { useClientSteps } from "./utils";
export type ProfileUploadType = {
  store: IRootStore;
  afterUpload?: () => any;
  loading?: boolean;
  onBack?: () => any;
  buttonText?: string;
};

const ProfilePhotoPage: React.FC<ProfileUploadType> = ({
  store,
  afterUpload,
  loading,
  onBack,
  buttonText = "Back to application",
}) => {
  const { onSubmitSection, getFormWrapperProps } = useClientSteps(
    STEPS.VERIFICATION,
    store,
  );

  const profilePhotoProps = {
    ...getFormWrapperProps(STEPS.VERIFICATION),
    buttonText: "Save",
    buttonProps: {
      width: "30%",
      float: "right",
      display: "none",
    },
    onSubmit: onSubmitSection,
  };
  return (
    <Box
      as="section"
      className="forms-section"
      maxW={["100%", "100%", "640px"]}
      px={[5, 8, 0]}
      py={[10, 12]}
      mx="auto"
    >
      <VerificationIdentity
        {...profilePhotoProps}
        includeValidId={false}
        afterUpload={afterUpload}
      />
      {onBack ? (
        <Box mt={10}>
          <Button
            alignSelf="flex-start"
            size="lg"
            colorScheme="blue"
            loadingText="Saving details"
            isLoading={loading}
            onClick={onBack}
          >
            {buttonText}
          </Button>
        </Box>
      ) : null}
    </Box>
  );
};

export default observer(ProfilePhotoPage);
